module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notes-list"
    }
  }, [_c('div', {
    attrs: {
      "id": "list-header"
    }
  }, [_c('h2', [_vm._v("Notes")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      active: !_vm.displayingFavourites
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleFavouriteView()
      }
    }
  }, [_vm._v("\n          All Notes\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: [{
      active: _vm.displayingFavourites
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleFavouriteView()
      }
    }
  }, [_vm._v("\n          Favorites\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.notes), function(note) {
    return _c('button', {
      staticClass: "list-group-item",
      class: {
        active: _vm.activeNote === note
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.updateActiveNote(note)
        }
      }
    }, [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [(note.favourite) ? _c('i', {
      staticClass: "glyphicon glyphicon-star star"
    }) : _vm._e(), _vm._v("\n          " + _vm._s(note.text.trim().substring(0, 30)) + "\n        ")])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0af3c2b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotesList.vue
// module id = 116
// module chunks = 2